export enum RandomOptions {
    Unknown = "Unknown",
    General = "General",
    EmphasizeArtists = "Emphasize Artists",
}